import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    mainGrid: {
        padding: "0px",
        margin: "0px",
        minHeight: "calc(100vh - 120px)",
        "@media (max-width: 767.98px)": {
            minHeight: "auto",
        },
    },
    sideStyle: {
        borderRightWidth: "20px",
        borderRightStyle: "solid",
        borderImage: "linear-gradient(#2156a4, #32a6c4e3) 30",
        "@media (max-width: 767.98px)": {
            borderRightWidth: 0,
            borderBottom: "8px solid #32a6c4",
        },
    },
    rowsStyle: {
        backgroundColor: "#e3eeff",
        borderRadius: "15px",
        margin: "0px"
    },
    imgDivStyle: {
        float: "right",
    },
    imgStyle: {
        //padding: "4px",
        cursor: "pointer"
    },
    editIconStyle: {
        width: "28px",
        cursor: "pointer",
    },
    deleteIconStyle: {
        width: "15px",
        cursor: "pointer",
    },
    buttonStyle: {
        textAlign: "center",
        height: "194px",
        width: "100%",
        backgroundColor: "white",
        border: "2px dotted black",
        color: "#088ee8"
    },
    newButtonStyle: {
        color: "#fff",
        ":focus" : {
          boxShadow: "none"
        },
      },
    headerStyle: {
        //borderBottom: "0px",
        //background: "#0d6cbf",
        padding: "10px 15px",
    },
    titleStyle: {
        fontSize: "18px",
        //color: "white",
    },
    bodyStyle: {
        padding: "5px",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "2px solid #76787a",
        paddingBottom: "10px",
        margin: "10px 0px 10px 0px",
        color: "black",
        fontSize: "18px",
        //fontFamily: "sans-sarif"
    },
    formGroupStyles: {
        display: "flex",
        verticalAlign: "middle",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 0px 8px 10px",
        //borderBottom: "1px solid #ccc",
        marginTop: "1em"
    },
    settingLabels: {
        fontSize: "16px",
        color: "black",
        textTransform: "capitalize"
    },
    valueLabels: {
        fontSize: "14px",
        color: "black",
        textTransform: "capitalize",
        padding: "0em 1em",
        width: "40%",
        display: "flex",
        justifyContent: "flex-end"
    },
    locationLabels: {
        fontSize: "14px",
        color: "black",
        textTransform: "capitalize",
    },
    cardLabel: {
        fontWeight: "500",
        width: "35%"
    },
    cardLabelValue: {
        //paddingLeft: "1em",
        width: "65%"
    },
    cardDiv: {
        display: "flex", 
        padding: "5px"
    }
});


export default styles;
